"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullFunction = void 0;
// eslint-disable-next-line
var NullFunction = function () { };
exports.NullFunction = NullFunction;
